export enum Buckets {
	Bucket1 = -1,
	Bucket2 = -2,
	Bucket3 = -3,
	Bucket4 = -4,
}